import type * as Types from 'app/types/graphql';

import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type ShopCleanupMutationVariables = Types.Exact<{
  appType: Types.AppType;
}>;

export type ShopCleanupMutationResponse = Pick<Types.Mutation, 'shopCleanup'>;

export const ShopCleanupDocument = `
    mutation ShopCleanup($appType: AppType!) {
  shopCleanup(appType: $appType)
}
    `;

export const useShopCleanupMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    ShopCleanupMutationResponse,
    TError,
    ShopCleanupMutationVariables,
    TContext
  >,
) => {
  return useMutation<ShopCleanupMutationResponse, TError, ShopCleanupMutationVariables, TContext>(
    ['ShopCleanup'],
    (variables?: ShopCleanupMutationVariables) =>
      appFetcher<ShopCleanupMutationResponse, ShopCleanupMutationVariables>(
        ShopCleanupDocument,
        variables,
      )(),
    options,
  );
};

useShopCleanupMutation.getKey = () => ['ShopCleanup'];
